<template>
  <component
    :is="tag"
    class="RunLocation"
  >
    <Icon
      class="RunLocation__icon"
      name="location"
    />
    <span class="RunLocation__label">{{ court?.name || "TBD" }}</span>
  </component>
</template>

<script lang="ts" setup>
import Icon from "@/components/Icon.vue";
import { CourtSummary } from "@shared/lib/database/query.types";

const {
  tag = "div",
} = defineProps<{
  court: CourtSummary | null,
  tag?: string,
}>();
</script>

<style lang="scss" scoped>
.RunLocation {
  --iconSize: 16px;

  display: grid;
  grid-template-columns: min-content auto;
  gap: 6px;
  align-items: center;

  font-size: 18px;
  font-weight: var(--fontWeightMedium);
  font-stretch: var(--fontWidthExtended);
}

.RunLocation__label {
  position: relative;
  top: max(1px, var(--fontSafariOffset));

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.RunLocation__icon {
  color: var(--iconColor, currentColor);
}
</style>
